import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Dropzone from "react-dropzone";
import CustomButton from "components/Button";
import { Card, Modal } from "reactstrap";
import CheckBox from "components/CheckBox";

const UploadPODModal = ({
  isPODExists,
  AWBNo,
  onSelect = () => { },
  show,
  onToggle,
  multiple = false,
  accept = ["image/*", "application/pdf"],
  loading,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [agree, setAgree] = useState(!isPODExists);
  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => {
    setShowModal(!!show);
    setAgree(!isPODExists);
    setSelectedFile(null);
  }, [show, setShowModal, isPODExists]);

  const onDrop = (files) => {
    setSelectedFile(files[0]);
  }

  return (
    <Modal
      zIndex={2000}
      centered
      size="md"
      isOpen={showModal}
      toggle={onToggle}
      contentClassName="modal-example-1 border-0 bg-transparent">
      <Card className="card-box px-4 py-3">
        <div className={"card-header pb-3"}>
          <div className="card-header--title font-weight-bold font-size-lg">
            Upload POD for {AWBNo}
          </div>
        </div>
        <div className="py-4 dropzone">
          <Dropzone onDrop={onDrop} multiple={multiple} accept={accept}>
            {({ getRootProps, getInputProps }) => (
              <div {...getRootProps()}>
                <input {...getInputProps()} />
                <div className="dz-message">
                  <div className="dx-text">
                    {
                      selectedFile ?
                        <h6><b>File: </b>{selectedFile.name}</h6>
                        :
                        <h5>Click to select files to upload.</h5>
                    }
                  </div>
                </div>
              </div>
            )}
          </Dropzone>
          {
            isPODExists &&
            <div className="text-danger mt-4">
              <h6>POD already exists for this order.</h6>
              <CheckBox
                label={"I agree to overwrite the existing POD"}
                checked={agree}
                onChange={(e) => setAgree(e.target.checked)}
              />
            </div>
          }
          <CustomButton
            className="mt-2"
            disabled={!selectedFile || !agree || loading}
            label={loading ? "Uploading..." : "Upload"}
            onClick={() => onSelect(selectedFile)}
          />
        </div>
      </Card>
    </Modal>
  );
};

UploadPODModal.defaultProps = {
  showModal: false
};

UploadPODModal.propTypes = {
  onAdd: PropTypes.func,
  showModal: PropTypes.bool,
  selectedProducts: PropTypes.array
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  // getAllStock
};

export default connect(mapStateToProps, mapDispatchToProps)(UploadPODModal);
